import { SortDirection } from "../../../components/Table/types"

export type ReleasedVersionsRequest = {
  idCliente: number
  filters: ReleasedVersionsFilters
}

export type ReleasedVersionsResponse = {
  versoesLiberadas: ReleasedVersion[]
  paginaAtual: number
  totalPaginas: number
  tamanhoPagina: number
  totalItens: number
}

export type ReleasedVersion = {
  data: string;
  dataLiberacao: string;
  descricaoTopico: string;
  numFicha: number;
  situacao: string;
  sistema: string;
  opcao: string;
  versao: string;
  nome: string;
  referenciaExterna: string;
  oidCliente: number;
  oidContato: number;
  actions?: any
};


export type ReleasedVersionsFilters = {
  dataInicial?: string
  dataFinal?: string
  dataInicialLiberacao?: string
  dataFinalLiberacao?: string
  descricaoTopico?: string
  numFicha?: number
  oidFicha?: number
  oidContato?: number
  pagina?: number
  tamanhoPagina?: number
  sentidoOrdenacao?: SortDirection
  campoOrdenado?: ColumnSort
}

export enum ColumnSort {
  RECORD_NUMBER = 'numficha',
  CREATED_AT = 'datainclusao',
  RELEASED_AT = 'dataliberacao',
  STATUS = 'situacao',
  REQUESTER = 'nome',
}
